import { render, staticRenderFns } from "./automaticPackingScanning.vue?vue&type=template&id=f2a2a746&scoped=true"
import script from "./automaticPackingScanning.vue?vue&type=script&lang=js"
export * from "./automaticPackingScanning.vue?vue&type=script&lang=js"
import style0 from "./automaticPackingScanning.vue?vue&type=style&index=0&id=f2a2a746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2a746",
  null
  
)

export default component.exports